var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkedinLogo = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 21",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M17.3 17.6h-3V13c0-1 0-2.5-1.6-2.5-1.5 0-1.8 1.2-1.8 2.5v4.7H8V8h2.9v1.3a3 3 0 0 1 2.9-1.6c3 0 3.6 2 3.6 4.6zM4.5 6.6a1.7 1.7 0 1 1 0-3.5 1.7 1.7 0 0 1 0 3.5m1.5 11H3V8h3zM18.8.4H1.5A1.5 1.5 0 0 0 0 1.8v17.4a1.5 1.5 0 0 0 1.5 1.4h17.3a1.5 1.5 0 0 0 1.5-1.4V1.8A1.5 1.5 0 0 0 18.8.4"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 .4h24v20.5H0z"
})))));
export default SvgLinkedinLogo;